
function Illyriad( props: any ) {
  return (
    <div>Illyriad Stuff</div>
  )
}

export default Illyriad;